<template>
  <HrPageLayout
    title="Training Evaluations"
    subtitle="Manage training feedback and evaluations"
    icon="📋"
    :breadcrumb-items="[
      { label: 'Dashboard', route: '/dashboard' },
      { label: 'Training & Development' },
      { label: 'Training Evaluations' }
    ]"
  >
    <div class="training-evaluations-content">
      <div class="hr-chart-card">
        <div class="hr-chart-body hr-text-center hr-py-5">
          <i class="bx bx-file-blank" style="font-size: 64px; color: #94a3b8;"></i>
          <h5 class="hr-mt-4">Training Evaluations</h5>
          <p class="hr-text-muted hr-mb-4" style="max-width: 480px; margin-left: auto; margin-right: auto;">
            Collect and review post-training feedback and evaluations. This module can be extended to add evaluation forms, surveys and reports.
          </p>
          <div class="hr-d-flex hr-gap-2 hr-justify-center hr-flex-wrap">
            <button type="button" class="hr-btn hr-btn-outline-primary" disabled>
              <i class="bx bx-plus"></i> Add Evaluation Form (coming soon)
            </button>
            <button type="button" class="hr-btn hr-btn-outline" @click="$router.push('/trainings-catalog')">
              <i class="bx bx-book"></i> Go to Trainings Catalog
            </button>
          </div>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";

export default {
  name: "TrainingEvaluations",
  components: { HrPageLayout }
};
</script>

<style scoped>
.training-evaluations-content { padding: 0; }
</style>
